/**
 * Toggle Switch Component
 * A pill-shaped toggle switch with smooth animation
 */

import { cn } from "@utils/cn";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  "aria-label"?: string;
}

export function Toggle({
  checked,
  onChange,
  disabled = false,
  "aria-label": ariaLabel,
}: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        "toggle-switch relative inline-flex flex-shrink-0 cursor-pointer transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
        checked ? "bg-primary-500" : "bg-gray-300 dark:bg-gray-600",
        disabled && "cursor-not-allowed opacity-50",
      )}
      style={{
        width: "44px",
        height: "24px",
        borderRadius: "9999px",
        border: "none",
        padding: "2px",
      }}
    >
      <span
        className="pointer-events-none inline-block bg-white shadow ring-0 transition duration-200 ease-in-out"
        style={{
          width: "20px",
          height: "20px",
          borderRadius: "9999px",
          transform: checked ? "translateX(20px)" : "translateX(0px)",
        }}
      />
    </button>
  );
}
